import React, { Component } from 'react';
import Know from '../know/know';
import { t } from '../i18n';

export default class KnowFrame extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,  // 初始化为加载状态
            initialized: false,
        };
        this.knowRef = React.createRef();  // 知识库组件的ref
    }

    componentDidMount() {
        // 延迟初始化Know组件，模拟异步加载
        setTimeout(() => {
            this.setState({
                loading: false,
                initialized: true
            });
        }, 300);
    }

    componentDidUpdate(prevProps) {
        // 如果需要，可以在这里处理props变化
    }

    componentWillUnmount() {
        // 清理工作
    }

    // 获取Know组件实例
    getKnowInstance = () => {
        return this.knowRef.current;
    }

    // 重置知识库到列表视图
    resetToList = () => {
        if (this.knowRef.current && this.knowRef.current.resetToList) {
            this.knowRef.current.resetToList();
        }
    }

    // 处理知识库视图变化（列表 <-> 详情）
    handleViewChange = (view, scale) => {
        if (this.props.onViewChange) {
            this.props.onViewChange(view, scale);
        }
    }

    render() {
        const { isMobile, paymentCatAppId, host, fromData, conf, theme } = this.props;
        const { loading, initialized } = this.state;

        // 标准化isMobile值
        const isMobileBoolean = isMobile === "true" || isMobile === true;

        // 准备Know组件的props
        const knowProps = {
            appId: paymentCatAppId,  // 将 paymentCatAppId 映射为 appId
            host,
            isMobile: isMobileBoolean,
            fromData: fromData || {},
            conf: theme || conf || {},
            theme: theme || conf || {},
            appConfig: this.props.appConfig || null, // kb_public_base_url 等（详情页外链按钮）
            // 版式档位 auto|flat|nested（widget 侧已归一，见 Widget::_kbLayoutMode）
            kbLayoutMode: this.props.kbLayoutMode || 'auto',
            onViewChange: this.handleViewChange,
            // 直达文章详情（home 的帮助文章条目）+ 来路，见 Know 构造函数注释
            initialArticle: this.props.initialArticle || null,
            initialReturnTo: this.props.initialReturnTo || null,
            onExit: this.props.onExit,
        };

        return (
            <div
                style={{
                    position: 'relative',
                    width: '100%',
                    height: isMobileBoolean ? 'calc(100% - 30px)' : '100%',
                    background: 'var(--lc-surface, #fff)'
                }}
            >
                {loading && (
                    <div
                        style={{
                            position: 'absolute',
                            top: 0, left: 0, right: 0, bottom: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            backgroundColor: 'var(--lc-bg, #f8f9fa)',
                            zIndex: 1000
                        }}
                    >
                        <div
                            style={{
                                width: '40px',
                                height: '40px',
                                border: '4px solid var(--lc-surface-2, #f3f3f3)',
                                borderTop: '4px solid var(--widget-main-color, #2563eb)',
                                borderRadius: 'var(--lc-radius-full)',
                                marginBottom: '20px',
                                animation: 'spin 1s linear infinite'
                            }}
                        ></div>
                        <span style={{
                            color: 'var(--lc-text-2, #6c757d)',
                            fontSize: '14px'
                        }}>{t('know.loading_kb')}</span>
                    </div>
                )}

                {initialized && (
                    <div
                        style={{
                            width: '100%',
                            height: '100%',
                            overflow: 'hidden',
                            position: 'relative'
                        }}
                    >
                        {/*
                            Know 组件容器的样式。名字里的 "frame" 是历史遗留：这块以前真的是
                            一个 iframe（知识库跑在独立文档里），现在容器里只有 <Know> 这个
                            同文档 React 组件。

                            这里曾经还有两条规则，2026-08-10 删除 —— 都是 iframe 时代的残骸。
                            说明写在 JSX 注释里而不是 CSS 注释里：<style> 里的内容会原样打进
                            bundle 发到每个访客那儿，解释给维护者看的话没必要占那个带宽。

                              1) `.know-frame-container iframe`（铺满 + position:absolute）
                                 当年是把知识库那个 iframe 撑满容器用的。iframe 早就没了，
                                 容器里只剩 <Know>。而它不是"无害的死代码"：KB 正文走的是
                                 KnowledgeDetail 的 dangerouslySetInnerHTML，商户在文章里插
                                 一个视频嵌入（YouTube 之类）就是一个 iframe，正好落进这条
                                 选择器。无头实测：560x315 的嵌入被改成 position:absolute
                                 400x640，把整个面板糊住。删掉后嵌入按自己的尺寸走。

                              2) `.know-frame-container div[style*="position: fixed"]`
                                 （改写成居中卡片）瞄的是老 iframe 内部那个 position:fixed 的
                                 加载提示浮层。它跟着 iframe 一起消失了 —— 现在的加载态是本文件
                                 上面 loading && 那一段，内联 position:absolute，而且渲染在
                                 .know-frame-container 之外，压根不匹配。同样会误伤正文里任何带
                                 position: fixed 内联样式的元素。

                            第 2 条身上带过一句"暗色亮斑已修"的注释：那个修法从来没作用到任何
                            元素上，别把它当成"加载浮层的暗色问题处理过了"。真正在用的加载浮层
                            用的是 var(--lc-bg) / var(--lc-text-2)，本身就跟主题。
                        */}
                        <style>{`
                            .know-frame-container {
                                width: 100% !important;
                                height: 100% !important;
                                position: relative !important;
                                background: var(--lc-surface, #fff) !important;
                                overflow: hidden !important;
                            }

                            .know-frame-container > div {
                                width: 100% !important;
                                height: 100% !important;
                                position: relative !important;
                            }
                        `}</style>
                        <div className="know-frame-container">
                            <Know
                                ref={this.knowRef}
                                {...knowProps}
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}